import { FC } from "react";
import { StyleSection } from "./components/StyleSection/StyleSection";
import { PositionSection } from "./components/PositionSection/PositionSection";

export const AppearanceIconTab: FC = () => {
  return (
    <div className="flex flex-col gap-14">
      <StyleSection />
      <PositionSection />
    </div>
  );
};
